var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.72726 5.1585H9.51764V7.09091L13 3.54546L9.51764 0V1.93241H4.72726V5.1585Z",
    fill: "#0090C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27273 11.0676H3.48231V13L0 9.45451L3.48231 5.90906V7.84147H8.27273V11.0676Z",
    fill: "#0090C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransfer);
export default __webpack_public_path__ + "static/media/icon-transfer.161f33ad27ecc6a2dbf1808cbff9ef6a.svg";
export { ForwardRef as ReactComponent };